export default {
  REPLACE_MY_DEPARTMENT: 'REPLACE_MY_DEPARTMENT',
  RESET_MY_DEPARTMENT_STATE: 'RESET_MY_DEPARTMENT_STATE',
  SET_MY_DEPARTMENT: 'SET_MY_DEPARTMENT',
  SET_MY_DEPARTMENT_IS_LOADING: 'SET_MY_DEPARTMENT_IS_LOADING',
};
